exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-kamp-tara-tsx": () => import("./../../../src/pages/kamp-tara.tsx" /* webpackChunkName: "component---src-pages-kamp-tara-tsx" */),
  "component---src-pages-kontakt-tsx": () => import("./../../../src/pages/kontakt.tsx" /* webpackChunkName: "component---src-pages-kontakt-tsx" */),
  "component---src-pages-o-klubu-tsx": () => import("./../../../src/pages/o-klubu.tsx" /* webpackChunkName: "component---src-pages-o-klubu-tsx" */)
}

